var map = {
	"./AnswerBoard.js": "db93",
	"./course.js": "a700",
	"./courseView.js": "e5da",
	"./courseViewQxt.js": "9969",
	"./exam.js": "3020",
	"./forgot.js": "d303",
	"./help.js": "bef4",
	"./lectureNotes.js": "c704",
	"./questionBank.js": "337d",
	"./record.js": "1902",
	"./user.js": "499f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c77";